import $ from "jquery";
import Field from "./../field";

const Text = (($) => {
  class Text extends Field {
    render() {
      let id = this.getForm().getID() + "_field_" + this._field.name;

      this._element = document.createElement("div");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-text");

      // Label
      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Default Value
      //   let defaultValue = this.getSetting("defaultValue");
      const value = this.getValue();

      // Placeholder
      let placeholder = this.getSetting("placeholder");

      // Input
      this._input = document.createElement("input");
      this._input.id = id;
      this._input.type = "text";
      this._input.classList.add("ion-form-control");
      this._input.name = this._field.name;
      this._input.ariaLabel = this._field.label;
      this._input.required = isRequired == 1;

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
        this._input.ariaRequired = true;
      }

      this._element.appendChild(this._input);

      if (placeholder) {
        this._input.placeholder = placeholder;
        this._input.ariaLabel = placeholder;
      }

      if (value) {
        this._input.value = value;
      }

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return Text;
})($);

export default Text;
